import { useEffect, useState } from 'react'

type MenuItem =
  | { label: string; href: string; external?: boolean }
  | { label: string; action: 'logout' }

const menuItems: MenuItem[] = [
  { label: '使い方ガイド', href: '/online_clinic/guide' },
  { label: '会員情報', href: '/account' },
  { label: 'お友達紹介', href: '/referral' },
  { label: 'ヘルプ', href: 'https://anamne.wraptas.site/', external: true },
  { label: 'カスタマーサポート', href: '/contacts/new' },
  { label: 'おうち病院サービストップ', href: '/' },
  { label: '利用規約', href: 'https://anamne.com/rules/', external: true },
  { label: 'プライバシーポリシー', href: 'https://anamne.com/privacy/', external: true },
  { label: 'ログアウト', action: 'logout' },
]

function submitLogout() {
  const csrfToken = (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null)?.content ?? ''
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = '/users/sign_out'
  form.style.display = 'none'

  const method = document.createElement('input')
  method.type = 'hidden'
  method.name = '_method'
  method.value = 'delete'
  form.appendChild(method)

  const token = document.createElement('input')
  token.type = 'hidden'
  token.name = 'authenticity_token'
  token.value = csrfToken
  form.appendChild(token)

  document.body.appendChild(form)
  form.submit()
}

export default function PatientHamburgerMenu() {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (!open) return
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false)
    }
    window.addEventListener('keydown', handleEsc)
    document.body.style.overflow = 'hidden'
    return () => {
      window.removeEventListener('keydown', handleEsc)
      document.body.style.overflow = ''
    }
  }, [open])

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="メニューを開く"
        aria-expanded={open}
        className="flex flex-col justify-center items-center w-10 h-10 gap-[5px]"
      >
        <span className="block w-[22px] h-[3px] rounded bg-[#04aae4]" />
        <span className="block w-[22px] h-[3px] rounded bg-[#04aae4]" />
        <span className="block w-[22px] h-[3px] rounded bg-[#04aae4]" />
      </button>

      {open && (
        <>
          <button
            type="button"
            aria-label="メニューを閉じる"
            onClick={() => setOpen(false)}
            className="fixed inset-0 z-[55] bg-black/20"
          />
          <nav
            role="menu"
            aria-label="ナビゲーション"
            className="fixed top-0 left-0 right-0 z-[60] bg-white shadow-lg max-h-[90vh] overflow-y-auto"
          >
            <div
              className="h-[8px] w-full"
              style={{ background: 'linear-gradient(to right, #00bcd4, #2196f3)' }}
            />
            <div className="flex items-center justify-between px-4 py-3 border-b border-[#e4e4e9]">
              <span className="text-[16px] font-semibold text-[#2a3039]">メニュー</span>
              <button
                type="button"
                onClick={() => setOpen(false)}
                aria-label="閉じる"
                className="w-8 h-8 flex items-center justify-center text-[#6f7680] text-2xl leading-none"
              >
                ×
              </button>
            </div>
            <ul className="py-2">
              {menuItems.map((item) => (
                <li key={item.label} className="px-4">
                  {'action' in item ? (
                    <button
                      type="button"
                      role="menuitem"
                      onClick={submitLogout}
                      className="block w-full text-left py-3 text-[14px] text-[#2a3039] border-b border-[#f0f2f5] last:border-b-0"
                    >
                      {item.label}
                    </button>
                  ) : (
                    <a
                      role="menuitem"
                      href={item.href}
                      target={item.external ? '_blank' : undefined}
                      rel={item.external ? 'noopener noreferrer' : undefined}
                      className="block py-3 text-[14px] text-[#2a3039] no-underline border-b border-[#f0f2f5] last:border-b-0"
                    >
                      {item.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </nav>
        </>
      )}
    </>
  )
}
